<template>
  <div class="animated fadeInUp" id="dashboard">
    <h3 class="text-bold d-none d-lg-block">Dashboard</h3>
    <div class="section is-relative">
      <div class="has-text-centered">
          <div class="has-text-centered">
            <div class="pt-10">
              <router-view></router-view>
            </div>
          </div>
      </div>
      <FooterSpacing/>
    </div>
  </div>
</template>
<script>
//import DoughnutChart from '../utils/DoughnutChart.vue';
import store from '../store';
import TransactionAPI from '../api/transactions_api';
import { tableMixin } from '../utils/table.mixin';
import spinner from '../utils/Spinner';
import EmptyTable from '../utils/empty-table.vue';
import moment from 'moment';
import MobileTransaction from '../components/MobileTransaction.vue';
import FooterSpacing from '../components/FooterMobile.vue';
import StatusButton from '../components/StatusButton.vue';

export default {
  mixins: [
    tableMixin
  ],
  components: {
    //DoughnutChart,
    spinner,
    EmptyTable,
    MobileTransaction,
    FooterSpacing,
    StatusButton
  },
  data() {
    return {
      filter_mobile: {},
      search: '',
      loadingTransactions: false,
      loading: false,
      authenticated: '',
      headerTag: {
        'animated fadeIn': false,
        hidden: true,
      },
      loggedInUser: {},
      masterTableProps: {
        fields: [
          {
            key: 'created_at',
            sortable: true,
            label: 'Date'
          },
          {
            key: 'service_type.name',
            sortable: false,
            label: 'Type'
          },
          {
            key: 'service_reference',
            sortable: true,
            label: 'Number'
          },
          {
            key: 'short_id',
            sortable: false,
            label: 'JetpayID'
          },
          {
            key: 'payer_account.name',
            sortable: true,
            label: 'Payer'
          },
          {
            key: 'transaction_amount',
            sortable: false,
            label: 'Amount'
          },
          {
            key: 'status',
            sortable: false,
            label: 'Status'
          }
        ],
        resultsPerPage: 10,
        currentPage: 1,
        sortBy: 'created_at',
        sortDirection: 'asc',
        totalRows: 1,
        sortDesc: true
      }
    };
  },
  props: ['session'],
  beforeMount() {
    this.tokenizer();
    this.getCurrentUser();
    //this.init();
  },
  mounted() {
    this.tokenizer();
    this.$root.$emit('showMenu');
    this.startLoading();

    setTimeout(() => {
      this.headerTag = {
        'animated fadeInUp': true,
        hidden: false,
      };
      setTimeout(() => {
        this.headerTag = {
          'animated fadeInDown': false,
          hidden: false,
        };
        this.getCurrentUser();
      }, 1500);
    }, 100);
  },
  computed: {
    transactionsIsReady () {
      if (this.axiosRequestAmount == 0) {
        return false
      }

      return true
    },
    axiosRequestAmount: {
      get: function () {
        return store.state.axiosRequestAmount;
      },
      set: function (newValue) {
        store.state.axiosRequestAmount = newValue;
      }
    },
    vendorStats: {
      get: function () {
        return store.state.vendorStats;
      },
      set: function (newValue) {
        store.state.vendorStats = newValue;
      }
    },
    transactions: {
      get: function () {
        return store.state.transactions;
      },
      set: function (newValue) {
        store.state.transactions = newValue;
      }
    },
    dailyPaymentGuarantee: function () {
      const statData = store.state.vendorStats;
      
      return {
        labels: ['Used', 'Unused'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: ['#f87979','#18b291'],
            data: [
                  statData.guarantee_used, 
                  statData.guarantee_left]
          }
        ]
      };
    }
  },
  methods: {
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY h:mm A');
    },
    tokenizer() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
        window.location.href = './login';
      }
    },
    getCurrentUser() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
      } else {
        this.loggedInUser = userContext.user_digest;
      }
    },
    init() {
      this.loadingTransactions = true
      TransactionAPI.methods.getVendorDashboardStats();
      TransactionAPI.methods.getTransactions()
      .then(verResponse => {
        this.loadingTransactions = false

      })
      .catch(error => {
          console.log('error', error);
      });
    },
    startLoading() {
      this.loading = true
      this.loadingTime = 0
    },
    isNegative(number) {
      if (number < 0) {
        return true;
      } 

      return false;
    },
    truncateString(string) {
      return string.substring(0, 15);
    }
  },
  watch: {
    vendorStats() {
      if (this.vendorStats) {
        this.loading = false
      }
    }
  }
};
</script>
<style scoped>
@import '../assets/css/table.css';
.section .title-divider {
  margin: auto;
  width: 100px;
  height: 5px;
  background: #00a27f;
}
.light-subtitle {
  font-size: 1.5rem;
  padding: 2% 10% 2% 10%;
  margin-bottom: 0 !important;
  font-weight: 400;
  line-height: normal;
  font-family: Roboto, sans-serif;
}
.text-big {
  font-size: 3em;
}
.text-blue {
  color: #0085ba;
}
.background-light-gray {
  background: #f2f2f2;
}
.red {
  color: red;
}
.green { 
  color: green;
}
.b-skeleton-wrapper {
  width: 90%;
}
.reflect-rotate {
  transform: rotate(275deg) scaleX(-1);
}
@media (min-width: 768px) {
  .d-md-inline-table {
    display: inline-table !important;
  }
}
@media (max-width: 768px) {
  .rounded-pill {
    border-radius: 5px !important;
  }
}
</style>
